import { render } from "./details.vue?vue&type=template&id=2f7f1882&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"

import "./details.vue?vue&type=style&index=0&id=2f7f1882&lang=scss&scoped=true"
import "./details.vue?vue&type=style&index=1&id=2f7f1882&lang=css"
script.render = render
script.__scopeId = "data-v-2f7f1882"

export default script